export function downloadByPost({axios, url, data = {}, success, faild, complete}) {
    const queryArgs = {
        url,
        method: 'post',
        data,
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        withCredentials: true,
        },
        responseType:'blob',
    };
    // tips: 这里直接返回的是response整体!
    axios
    .request(queryArgs)
    .then(response => {
        success && success(response);
    })
    .catch(err => {
        faild && faild(err);
    })
    .finally(() => {
        complete && complete();
    });
}

export function downloadByUrl(url, filename = 'file') {
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
}

export function convertRes2Blob(response) {
    // 提取文件名
    const filename = response.headers['content-disposition'].match(
        /filename=(.*)/
    )[1];
    // 将二进制流转为blob
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
        window.navigator.msSaveBlob(blob, decodeURI(filename));
    } else {
        // 创建新的URL并指向File对象或者Blob对象的地址
        const blobURL = window.URL.createObjectURL(blob);
        downloadByUrl(blobURL, decodeURI(filename));
    }
}
